import React from "react";
import { MessageCircle, Phone, Mail, MapPin } from "lucide-react";
import { WHATSAPP_URL, PHONE, PHONE_TEL } from "../mock";

const Footer = () => {
  return (
    <footer className="bg-[#070b14] border-t border-white/5">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-14">
        <div className="grid md:grid-cols-[1.4fr_1fr_1fr_1fr] gap-10">
          <div>
            <div className="flex items-center gap-3">
              <img
                src="https://customer-assets.emergentagent.com/job_language-test-portal/artifacts/jcixqklr_ccpl-logo-4.2%20%283%29.png"
                alt="Competitive Careers"
                className="h-11 w-11 object-contain rounded-xl bg-black/60 ring-1 ring-white/10 flex-shrink-0"
              />
              <div>
                <div className="text-white font-semibold tracking-tight">
                  Competitive <span className="text-amber-400">Careers</span>
                </div>
                <div className="text-[10.5px] tracking-[0.18em] uppercase text-slate-400">Pvt. Ltd. · Since 2003</div>
              </div>
            </div>
            <p className="mt-5 text-slate-400 text-[14px] leading-relaxed max-w-md">
              Ahmedabad's #1 study abroad consultant. 23+ years of unmatched excellence. 8,000+ visas approved across Australia, UK, New Zealand, USA and Canada.
            </p>
          </div>

          <div>
            <div className="text-[11px] tracking-[0.2em] uppercase text-slate-500">Offer</div>
            <ul className="mt-4 space-y-2.5 text-slate-300 text-[14px]">
              <li><a href="#offer" className="hover:text-white transition-colors">Cashback offer</a></li>
              <li><a href="#destinations" className="hover:text-white transition-colors">Destinations</a></li>
              <li><a href="#how" className="hover:text-white transition-colors">How it works</a></li>
              <li><a href="#apply" className="hover:text-white transition-colors">Apply free</a></li>
            </ul>
          </div>

          <div>
            <div className="text-[11px] tracking-[0.2em] uppercase text-slate-500">Company</div>
            <ul className="mt-4 space-y-2.5 text-slate-300 text-[14px]">
              <li><a href="https://www.competitivecareers.in/" target="_blank" rel="noreferrer" className="hover:text-white transition-colors">Main site</a></li>
              <li><a href="#why" className="hover:text-white transition-colors">Awards</a></li>
              <li><a href="#stories" className="hover:text-white transition-colors">Stories</a></li>
              <li><a href="#faq" className="hover:text-white transition-colors">FAQ</a></li>
            </ul>
          </div>

          <div>
            <div className="text-[11px] tracking-[0.2em] uppercase text-slate-500">Contact</div>
            <ul className="mt-4 space-y-2.5 text-slate-300 text-[14px]">
              <li>
                <a href={WHATSAPP_URL} target="_blank" rel="noreferrer" className="inline-flex items-center gap-2 hover:text-white transition-colors">
                  <MessageCircle className="h-4 w-4 text-emerald-400" /> WhatsApp
                </a>
              </li>
              <li>
                <a href={`tel:${PHONE_TEL}`} className="inline-flex items-center gap-2 hover:text-white transition-colors">
                  <Phone className="h-4 w-4 text-amber-400" /> {PHONE}
                </a>
              </li>
              <li>
                <a href="mailto:info@competitivecareers.in" className="inline-flex items-center gap-2 hover:text-white transition-colors">
                  <Mail className="h-4 w-4 text-amber-400" /> info@competitivecareers.in
                </a>
              </li>
              <li className="inline-flex items-center gap-2">
                <MapPin className="h-4 w-4 text-amber-400" /> Ahmedabad, India
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-white/5 flex flex-col md:flex-row items-center justify-between gap-3 text-slate-500 text-[12.5px]">
          <div>
            © {new Date().getFullYear()} Competitive Careers Pvt Ltd. All rights reserved.
          </div>
          <div className="flex items-center gap-5">
            <a href="#" className="hover:text-slate-300 transition-colors">Privacy</a>
            <a href="#" className="hover:text-slate-300 transition-colors">Terms</a>
            <a href="#" className="hover:text-slate-300 transition-colors">Cookies</a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
